import React from 'react';
import PropTypes from 'prop-types';

const ProductStepperStep = ({ children, activeStep, stepName }) => {
  const activeClass = activeStep === stepName ? ' active' : '';

  return (
    <div className={`product-stepper-step${activeClass}`}>
      {children}
    </div>
  );
};

ProductStepperStep.propTypes = {
  children: PropTypes.element,
  activeStep: PropTypes.string.isRequired,
  stepName: PropTypes.string.isRequired,
};

export default ProductStepperStep;
